import React,{useState} from 'react'
import { Btn1, Header,ServiceCard,Faqs, Headings, WorkFlow } from '../../Module_Exporter/Module_Exporter'
import "./Home.css";
import { generate_random, trim_text } from '../../functions/functions';
import { home_page_data, website_routes } from '../../functions/DefaultValues';

import { Helmet } from 'react-helmet-async';


function Home() {




  // ........................ States Hooks --------------------
  const [faq_values,set_faq] = useState(home_page_data.faqs);
  const [services_detials,set_services_details] = useState(home_page_data.services);

// ------------ Functions -----------------

// -----------------------
 
// --------------------
function manage_faqs(open_id)
{
  if(open_id==null) return "";
  console.log(open_id);
  
  const new_faq =  faq_values.filter((el)=>{
                  if(el.id=== open_id)
                  {
                    el.active=!el.active;
                  }
                  else{
                    el.active=false;

                  }
                  return el;

                })
                console.log(new_faq);
                set_faq(new_faq);
  
}



  return (
    <>

    <Helmet>    
    <title>CodeSperix</title>
    </Helmet>
    <Header services={home_page_data.header.services} introPhrase={home_page_data.header.intro_phrase}/>
    <main className='main_container'>

    <Headings text_aos="fade-up"  aos='fade-up' text={home_page_data.main_heading_phrases.our_services} title1="Our" title2="Services" w="28%" c="c2"/>
    <section id="servcies_section">
      {
        services_detials.map((obj,i)=> <ServiceCard aos={i%2===0?"flip-left":"flip-right"} title={obj.title} url={website_routes.services_page+`#${obj.id}${i}`} icon={obj.icon} service_details={trim_text(obj.detial,120)} key={"id"+generate_random(8)}  />)
      }
    
    </section>
    <Headings text_aos="fade-up" aos='fade-up' text={home_page_data.main_heading_phrases.industries}  title1="industries" title2="we cover" w="49%" c="c2"/>
    <section id="industries_we_cover_section">
   <div className='industries_container'>

   {
  home_page_data.industries.map((e,i)=>  <article data-aos={i%2===0?"flip-left":"flip-right"} key={"id"+generate_random(8)} className={i%2===0?"industry_card":"industry_card_border_radius_2 industry_card"}>
      <i className={e.icon}></i>
      <h3>{e.title}</h3>
      </article> )
   }
   </div>

   <Btn1 aos="fade-up" cl="service_section_button" value="Get More Details" url={website_routes.contact_page} />
    
    </section>
    {/*  our_work_flow  */}
    <Headings text_aos="fade-up" aos='fade-up' text={home_page_data.main_heading_phrases.work_flow}  title1="Work" title2="Flow" w="50%" c="c2"/>
    <section id="our_work_flow">
      {
        home_page_data.strategy.map((e,i)=><WorkFlow key={"id"+generate_random(5)} title={e.title} index={i+1} />)
      }
     </section>
    
   {/* FAQs Section */}
   <Headings text_aos="fade-up" aos='fade-up' text={home_page_data.main_heading_phrases.faqs}  title1="Common" title2="Quiers(FAQs)" w="39%" c="c2"/>

   <section  id="faqs_section">
   <div data-aos="fade-right" className='left_faqs_container'>

    {
      faq_values.slice(0,faq_values.length/2).map(({query,ans,active,id},index)=><Faqs
      query={query} ans={ans} active={active} id={id} key={id}
      event_function={manage_faqs}
      />)
    }
    </div>
   <div data-aos="fade-left" className='right_faqs_container'>

    {
      faq_values.slice(faq_values.length/2).map(({query,ans,active,id},index)=><Faqs
      query={query} ans={ans} active={active} id={id} key={id}
      event_function={manage_faqs}
      />)
    }
    </div>
    
    
 
    
      

   </section>
   </main>

    </>

  )
}

export default Home;